
import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)


const store = new Vuex.Store({

    state: {
        isMobile: false,
    },

    mutations: {
        SET_IS_MOBILE(state, payload) {
            state.isMobile = payload
        }
    },


    actions: {
        setMobileStatus({ commit }, bool) {
            commit('SET_IS_MOBILE', bool)
        }
    },

})

export default store